import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "../cn";

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, invalid, rows = 4, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      rows={rows}
      aria-invalid={invalid ? "true" : undefined}
      className={cn(
        "border-charcoal/20 bg-cream text-body text-charcoal w-full rounded-md border px-3 py-2",
        "placeholder:text-muted",
        "focus-visible:ring-saffron focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1",
        "disabled:cursor-not-allowed disabled:opacity-50",
        invalid && "border-terracotta focus-visible:ring-terracotta",
        className,
      )}
      {...rest}
    />
  );
});
